<template>
  <div>
    <div class="header">
      <div class="top">
        <div class="topbox">
          <p>{{webName}}</p>

          <p class="phone"><span  @click="routerClick2('/bzzx')">帮助中心</span> <i class="el-icon-phone"></i>咨询热线: {{phone}}</p>
        </div>
      </div>
      <div class="heabox">
        <div class="headT">
          <div class="logo">
            <img :src="logo" alt="加载中..">
          </div>
          <div class="search">
            <div class="searchT">
              <!--<el-select v-model="select" slot="prepend" placeholder="全部">-->
                <!--<el-option label="医院" value="1"></el-option>-->
                <!--<el-option label="科室" value="2"></el-option>-->
                <!--<el-option label="专家" value="3"></el-option>-->
              <!--</el-select>-->
              <el-autocomplete
              porp=""
              style="width: 100%;"
              class="inline-input input-with-select"
              v-model="input3"
              :fetch-suggestions="querySearch"
              placeholder="请输入科室"
              :trigger-on-focus="false"
              @select="handleSelect"
              ></el-autocomplete>
              <!--<el-input placeholder="搜索科室" v-model="input3" class="input-with-select"></el-input>-->
              <el-button slot="append" @click="seach">搜索</el-button>
            </div>
            <!--<div class="searchB">-->
              <!--<span class="active">胸外科</span>-->
              <!--<span>肝胆外科</span>-->
              <!--<span>乳腺</span>-->
              <!--<span>妇科</span>-->
              <!--<span>头颈外科</span>-->
              <!--<span>神经外科</span>-->
              <!--<span>骨科</span>-->
              <!--<span>结直肠外科</span>-->
            <!--</div>-->
          </div>
          <!--<div class="phoneBox">-->
          <!--<div class="phoneI">-->
          <!--<i class="el-icon-phone"></i>-->
          <!--</div>-->
          <!--<div class="r">-->
          <!--<p>电话预约热线</p>-->
          <!--<p>010-118115888</p>-->
          <!--</div>-->
          <!--</div>-->
        </div>
        <div class="hdbox">
          <ul class="pathList">
            <li v-for="(item,index) in routerData" :class="index == indexs ? 'active' : ''" :key="item.index" @click="routerClick(item.path,index)">{{item.name}} <i v-if="item.type" class="el-icon-arrow-down el-icon--right"></i></li>
          </ul>
        </div>
        <div class="dhbox" v-if="show" @mouseleave="show = false">
          <div>
            <ul class="l">
              <li v-for="(item,index) in leftData" :key="index" @click="onTab(index, item.id)">{{item.name}}</li>
            </ul>
            <ul class="r">
              <li v-for="(item,index) in rightData" :key="index" @click="onTab2(index, item.id)">{{item.name}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <header class="m-header">
      <el-input
        prefix-icon="el-icon-search"
        placeholder="搜索医院、科室、专家"
        v-model="input3"
        class="input-with-select">
      </el-input>
      <img class="sdg" src="@/assets/image/menu_icon2.png" alt="" @click="showm">
    </header>
    <div class="menu-mask" v-if="mshow">
      <div class="menu-close">
        <p>快捷导航</p>
        <div class="menu-close-icon-box" @click="close">
          <img src="@/assets/image/close-icon.png" alt="">
        </div>
      </div>
      <div class="nav-box">
        <div class="item" v-for="(item,index) in routerData2" :key="item.index" @click="routerClick2(item.path,index)">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import server from '@/service/server.js'
export default {
    name: 'NavBar',
  data () {
    return {
      input3: '',
      select: '',
      show: false,
      mshow: false,
      routerData:[
        {
          name: '首页',
          path: '/'
        },
        {
          name: 'PETCT/MR 中心',
          path: '/hospitalList'
        },
        {
          name: 'PETCT/MR 专家',
          path: '/hospitalList2'
        },
        {
          name: 'PETCT/MR 资讯',
          path: '/zx'
        },
        {
          name: '导航',
          type: 'daohang'
        },
        {
          name: '预约指南',
          path: '/PET_TC_zx'
        }
        ,{
          name: '帮助中心',
          path: '/bzzx'
        }
      ],
      routerData2:[
        {
          name: '首页',
          path: '/'
        },
        {
          name: 'PETCT/MR 中心',
          path: '/hospitalList'
        },
        {
          name: 'PETCT/MR 专家',
          path: '/hospitalList2'
        },
        {
          name: 'PETCT/MR 资讯',
          path: '/zx'
        },
        {
          name: '预约指南',
          path: '/PET_TC_zx'
        },
        {
          name: '帮助中心',
          path: '/bzzx'
        }
      ],
      indexs: 0,
      leftData:[],
      rightData:[],
      webName: '',
      phone: '',
      logo: '',
      id: '',
      index: 'all',
    }
  },
    methods: {
      querySearch(queryString, cb) {
        var restaurants = this.deparList;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      seach() {
        this.indexs = 1
        this.$router.push({
          path: `hospitalList?type=1&index=${this.index}&id=${this.id}`
        })
        this.id = ''
        this.index = 'all'
      },
      handleSelect(item) {
        console.log(item);
        this.id = item.id
        this.deparList.map((items, index) => {
          if (items.id == item.id) {
            this.index = index
          }
        })
      },
      showm() {
        console.log(1111)
        this.mshow = true
      },
      close() {
        this.mshow = false
      },
      onTab(index, id) {
        this.$router.push({
          path: `hospitalList?type=1&index=${index}&id=${id}`
        })
        this.show = false
      },
      onTab2(index, id) {
        this.$router.push({
          path: `hospitalList?type=2&index=${index}&id=${id}`
        })
        this.show = false
      },
      routerClick(path,index){
        this.indexs = index
        this.mshow = false
        console.log(path === '/PET_TC_zx')
        if (this.routerData[index].type) {
          this.show = !this.show
        } else {
          this.$router.push({
            path: path
          })
        }
      },
      routerClick2(path){
        this.mshow = false
        this.$router.push({
          path: path
        })
      },
      getList() {
        server.area().then((res) => {
          this.rightData = res.data
        })
      },
      getList2() {
        server.department().then((res) => {
          this.leftData = res.data
        })
      }
    },
    computed: {
        realName(){
            let realName = this.$Fn.GetCookie('realName');
            return realName;
        }
    },
    mounted() {
      server.getWebName().then((res) => {
        this.webName = res.data.description
        window.document.title = this.webName
      })
      server.getTel().then((res) => {
        this.phone = res.data.introduction
        document.getElementById('kftel').innerHTML = this.phone
      })
      server.getMiniLogo().then((res) => {
        console.log(res.data)
        this.logo = res.data.picUrl
      })
      server.department().then((res) => {
        this.deparList = res.data
        this.deparList.forEach((item) => {
          item.value = item.name
          return item
        })
      })
      this.getList()
      this.getList2()
    }
}
</script>
<style lang="scss" scoped>
  .m-header {
    display: none;
  }
  /deep/ .el-input__inner{
    border: none;
    line-height: 47px;
    height: 47px;
  }
  .top {
    max-width: 1920px;
    margin: 0 auto 40px;
    height: 40px;
    background: #F8F8F8;
    border-bottom: 1px solid #D2D2D2;
    .topbox {
      width: 1370px;
      margin: 0 auto;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      .phone {
        color: #CB0E07;
        span {
          display: inline-block;
          border-right: 1px solid #333333;
          height: 16px;
          line-height: 16px;
          color: #333333;
          padding-right: 15px;
          margin-right: 15px;
        }
      }
    }
  }
  .dhbox {
    background-color: #F7F8FA;
    width: 1370px;
    /*height: 204px;*/
    position: absolute;
    left: 0;
    z-index: 20;
    top: 160px;
    box-sizing: border-box;
    padding: 25px 60px;
    div{
      display: flex;
      ul{
        width: 49%;
        box-sizing: border-box;
        /*display: flex;*/
        /*flex-wrap: wrap;*/
        li{
          font-size: 14px;
          font-weight: 400;
          color: #8B8B8B;
          line-height: 30px;
          height: 30px;
          margin: 0;
          padding: 0;
          cursor: pointer;
          float: left;
          &:hover {
            color: #CB0E07
          }
        }
        /*li.active{*/
          /*color: #CB0E07;*/
        /*}*/
      }
      ul.l{
        border-right: 2px dashed #ccc;
        li{
          margin-right: 50px;
        }
      }
      ul.r{
        li{
          margin-left: 50px;
        }
      }
    }
  }
  .header {
    width: 100%;
    /*height: 210px;*/
    /*padding-top: 50px;*/
    background-color: #FFFFFF;
    box-shadow: 0px 4px 2px #eaeaea;
    margin-bottom: 1px;
    padding-bottom: 15px;
    .heabox {
      width: 1370px;
      margin: 0 auto;
      position: relative;
      .headT{
        display: flex;
        img {
          width: 326px;
          height: 52px;
        }
        .search{
          margin-left: 54px;
          .searchT{
            width: 576px;
            height: 51px;
            border: 2px solid #CB0E07;
            display: flex;
            .el-input,.el-select{
              height: 100% !important;
              border: none;
              /deep/ .el-input__inner{
                height: 100% !important;
                border: none;
              }
            }
            .el-select{
              width: 25%;
              /deep/ .el-input{
                height: 100%;
              }
            }
            .el-button{
              width: 108px;
              height: 100%;
              background: #CB0E07;
              color: #fff;
              border-color: #CB0E07;
              border-radius: 0;
            }
          }
          .searchB{
            span{
              font-size: 15px;
              /*font-family: SourceHanSansCN;*/
              color: #757575;
              margin-right: 15px;
            }
            span.active{
              color: #CB0E07;
            }
          }
        }
        .phoneBox{
          margin-left: 154px;
          display: flex;
          .phoneI{
            line-height: 50px;
            margin-right: 10px;
            i{
              color: #CB0E07;
              font-size: 26px;
            }
          }
          .r{
            line-height: 20px;
            p:nth-child(1){
              font-size: 15px;
              /*font-family: SourceHanSansCN;*/
              font-weight: 400;
              color: #6C6C6C;
            }
            p:nth-child(2){
              font-size: 22px;
              /*font-family: Adobe Heiti Std;*/;
              font-weight: normal;
              color: #CB0E07;
            }
          }
        }
      }
      .pathList{
        display: flex;
        margin-top: 50px;

        li{
          cursor: pointer;
          font-size: 18px;
          /*font-family: Adobe Heiti Std;*/;
          font-weight: normal;
          color: #000;
          margin-right: 70px;
        }
        li.active{
          color: #CB0E07;
        }
      }
    }
  }

  @media (max-width: 750px) {
    .nav-box {
      display: flex;
      flex-wrap: wrap;
      .item {
        padding: 10px;
        margin: 10px;
      }
    }
    .menu-mask {
      width: 100%;
      height: 100%;
      background: #FFFFFF;
      position: fixed;
      padding: 20px;
      top: 0;
      left: 0;
      z-index: 9999;
      .menu-close {
        display: flex;
        justify-content: center;
        height: 30px;
        align-items: center;
        font-size: 18px;
        color: #000000;
        position: relative;
        .menu-close-icon-box {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 0px;
          top: 5px;
        }
      }
    }
    .m-header {
      display: flex;
      justify-content: space-between;
      padding:10px 20px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 23;
      .input-with-select {
        width: 200px;
        /*overflow: hidden;*/
        /*border-radius: 50px;*/
      }
      .sdg {
        width: 20px;
        height: 18px;
        display: block;
        margin-top: 5px;
      }
    }
    .header {
      width: 100%;
      height: auto;
      padding: 10px;
      overflow: hidden;
      margin-bottom: 2px;
      display: none;
      .top {
        display: none;
      }
      .heabox {
        width: 100%;
        .headT{
          display: block !important;
          .search {
            display: none;
          }
          .phoneBox {
            display: none;
          }
          img {
            height: auto;
          }
        }
        .hdbox {
          width: 100%;
          overflow-y: auto;
          .pathList {
            width: 800px;
            margin-top: 20px;
            li {
              margin-right: 30px;
              &:nth-child(5) {
                display: none;
              }
            }
          }
        }

      }
    }
  }
</style>
